module.exports = __webpack_public_path__ + "img/google-up.783c48cb.svg";